module.exports = __webpack_public_path__ + "img/logo-all-dark.029d512a.png";